import { Breakpoint, SpacingKey, SpacingRecord } from '../theme/type';

export const MARGIN_FALLBACK: SpacingRecord = { x: '0', y: '0.75em' };

export const HEIGHTS: Record<Breakpoint.MD | SpacingKey.X | SpacingKey.Y, string> = {
  [Breakpoint.MD]: '525px',
  [SpacingKey.X]: '440px',
  [SpacingKey.Y]: '220px',
};

export const WIDTHS: Record<Breakpoint.MD | Breakpoint.SM, string> = {
  [Breakpoint.MD]: '930px',
  [Breakpoint.SM]: '392px',
};
